var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.2782 15.8431L28.1569 13.7218L22.5 19.3786L16.8431 13.7218L14.7218 15.8431L20.3787 21.5L14.7218 27.1568L16.8431 29.2781L22.5 23.6213L28.1569 29.2781L30.2782 27.1568L24.6213 21.5L30.2782 15.8431Z","fill":"black","key":1})]);
}

Close.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Close;

Close.default = Close;
